// Traductions du parcours de signature — reprises telles quelles de la version du
// client (itération 40). Cinq langues, aucune dépendance : un objet, trois fonctions.
//
// Pourquoi pas i18next : le parcours installateur est le SEUL écran traduit, et il
// l'est pour une raison précise — les poseurs ne sont pas tous francophones et signent
// des mandats chez des clients. Ajouter une bibliothèque de 40 Ko et sa chaîne de
// chargement pour un dictionnaire statique serait payer cher une souplesse dont on n'a
// pas l'usage.
//
// Le moldave est conservé comme option distincte du roumain, à sa demande, bien que les
// deux partagent l'alphabet latin depuis 1989 et soient très proches.
//
// `translate` retombe sur le français quand une clé manque, jamais sur la clé brute :
// un poseur qui verrait « lbl_civilite » à l'écran serait plus perdu qu'avec un mot
// français qu'il ne comprend pas.

// Traductions CFTSign — 4 langues : FR (défaut), RO (Roumain), MO (Moldave), PL (Polonais)
// Note : le Moldave utilise l'alphabet latin depuis 1989 et est très proche du Roumain,
// mais gardé comme option séparée à la demande utilisateur.

// Le drapeau ne vit plus ici : il est DESSINE dans `Drapeaux.jsx`, indexe par ce meme
// code. Il y etait en emoji, et le selecteur en devenait muet sous Windows, qui
// n'embarque pas les glyphes d'indicatifs regionaux. Une donnee qui ne s'affiche pas
// partout n'a rien a faire dans un dictionnaire de langues.
export const LANGUAGES = [
  { code: 'fr', label: 'Français' },
  { code: 'en', label: 'English' },
  { code: 'ro', label: 'Română' },
  { code: 'mo', label: 'Moldovenească' },
  { code: 'pl', label: 'Polski' },
];

const TRANSLATIONS = {
  fr: {
    // Header / Navigation
    nav_home: 'Accueil',
    nav_new_chantier: 'Nouveau chantier',
    nav_my_chantiers: 'Mes chantiers',
    nav_new_short: 'Nouveau',
    nav_chantiers_short: 'Chantiers',
    nav_more: 'Plus',
    nav_team: 'Mon équipe',
    nav_profile: 'Mon profil',
    nav_logout: 'Déconnexion',
    role_installateur: 'Installateur',
    role_poseur: 'Poseur',
    // Wizard steps
    step1_title: 'Informations client',
    section_logement: 'Informations logement',
    lbl_civilite: 'Civilité',
    lbl_type_logement: 'Type de logement',
    lbl_surface: 'Surface (m²)',
    lbl_mode_chauffage: 'Mode de chauffage',
    lbl_region: 'Région',
    lbl_region_placeholder: 'Sélectionner une région',
    lbl_pdl_prm_hint: '14 chiffres',
    lbl_find_pdl: 'Trouver son PDL',
    lbl_step_progress: 'Étape',
    step2_title: 'Équipement installé',
    step3_title: 'Consentements & signature',
    step4_title: 'Récapitulatif',
    field_reference_chantier: 'Référence chantier',
    field_reference_chantier_hint: 'Votre référence de chantier (obligatoire). Elle reste libre : nous y ajoutons notre identifiant.',
    field_client_prenom: 'Prénom client',
    field_client_nom: 'Nom client',
    field_client_email: 'Email client',
    field_client_telephone: 'Téléphone client',
    field_obligatoire: 'Obligatoire',
    field_adresse: 'Adresse du chantier',
    field_code_postal: 'Code postal',
    field_ville: 'Ville',
    field_pdl_prm: 'N° PRM / PDL',
    // Equipements sections
    equip_section_title: 'Équipement installé',
    equip_pv: 'Panneaux photovoltaïques (PV)',
    equip_batterie: 'Batterie de stockage',
    equip_ballon: 'Ballon d\'eau chaude',
    equip_pac: 'Pompe à chaleur (PAC)',
    equip_radiateur: 'Radiateur électrique',
    equip_activate: 'Activer',
    // Field labels (fields shared or specific)
    lbl_puissance_kwc: 'Puissance totale (kWc)',
    lbl_puissance_kw: 'Puissance (kW)',
    lbl_marque: 'Marque',
    lbl_modele: 'Modèle',
    lbl_reference: 'Référence',
    lbl_type_onduleur: 'Type d\'onduleur',
    lbl_onduleur_centralise: 'Onduleur centralisé',
    lbl_onduleur_centralise_desc: '1 seul onduleur pour tous les panneaux',
    lbl_onduleur_micro: 'Micro-onduleurs',
    lbl_onduleur_micro_desc: '1 micro-onduleur par panneau (Hoymiles…)',
    lbl_id_centrale: 'ID centrale',
    lbl_onduleur_marque: 'Marque onduleur',
    lbl_onduleur_modele: 'Modèle onduleur',
    lbl_onduleur_serial: 'Numéro de série onduleur',
    lbl_panneaux_section: 'Panneaux photovoltaïques',
    lbl_panneau_marque: 'Marque panneau',
    lbl_panneau_modele: 'Modèle panneau',
    lbl_nombre_panneaux: 'Nombre de panneaux',
    lbl_puissance_panneau: 'Puissance / panneau (Wc)',
    lbl_serie_pac: 'Numéro de série PAC',
    lbl_serie_pac_int: 'Numéro de série unité intérieure',
    lbl_serie_pac_ext: 'Numéro de série unité extérieure',
    lbl_thermostat_ref: 'Référence thermostat',
    lbl_thermostat_serial: 'Numéro de série thermostat',
    lbl_type_ballon: 'Technologie',
    lbl_nombre_ballons: 'Nombre de ballons',
    lbl_radiateur_rang: 'Radiateur',
    btn_ajouter_radiateur: 'Ajouter un radiateur',
    btn_retirer: 'Retirer',
    lbl_identifiant_equipement: 'Identifiant équipement',
    lbl_date_installation: 'Date d\'installation',
    lbl_photos_section: 'Photos étiquettes N° série (obligatoires)',
    lbl_optional: '(optionnel)',
    lbl_required_symbol: ' *',
    // Buttons
    btn_next: 'Suivant',
    btn_previous: 'Précédent',
    btn_confirm: 'Confirmer & signer',
    btn_finalize: 'Finaliser',
    // Home Poseur
    poseur_hello: 'Bonjour',
    poseur_welcome_msg: 'Prêt à démarrer un nouveau chantier ?',
    poseur_stat_month: 'Chantiers ce mois',
    poseur_stat_total: 'Total',
    poseur_new_chantier_btn: 'Nouveau chantier',
    poseur_last_chantiers: 'Mes derniers chantiers',
    poseur_no_chantiers: 'Aucun chantier réalisé pour le moment.',
    poseur_see_all: 'Voir tout',
    status_signed: 'Signé',
    status_pending: 'En attente',
    // Home Installateur
    inst_welcome: 'Bienvenue',
    inst_stat_month: 'Chantiers ce mois',
    inst_stat_total: 'Total chantiers',
    inst_quick_create_poseur_title: 'Créer un poseur',
    inst_quick_create_poseur_desc: 'Nouveau technicien terrain',
    inst_quick_see_chantiers_title: 'Voir mes chantiers',
    inst_quick_see_chantiers_desc: 'Historique complet',
    inst_my_poseurs: 'Mes poseurs',
    inst_manage_team: 'Gérer l\'équipe',
    inst_no_poseurs: 'Aucun poseur pour le moment. Créez-en un pour démarrer.',
    inst_last_chantiers: 'Derniers chantiers réalisés',
    inst_no_last_chantiers: 'Aucun chantier réalisé.',
    inst_by: 'Par',
    connection_connected: 'Connecté (< 24h)',
    connection_inactive: 'Inactif',
    connection_disabled: 'Désactivé',
    chantier_singular: 'chantier',
    chantier_plural: 'chantiers',
    // Team management
    team_title: 'Mon équipe',
    team_subtitle: 'Gérez les comptes de vos poseurs terrain',
    team_new_poseur: 'Nouveau poseur',
    team_no_poseur_title: 'Aucun poseur créé',
    team_no_poseur_desc: 'Créez le premier compte poseur pour votre équipe terrain.',
    team_created_on: 'Créé le',
    team_edit: 'Modifier',
    team_deactivate: 'Désactiver',
    team_reactivate: 'Réactiver',
    team_delete: 'Supprimer',
    // Dialog Poseur
    poseur_dialog_create_title: 'Créer un compte poseur',
    poseur_dialog_edit_title: 'Modifier le poseur',
    poseur_dialog_create_desc: 'Le poseur pourra se connecter à CFTSign avec les identifiants ci-dessous et signer des chantiers en votre nom.',
    poseur_dialog_edit_desc: 'Modifier les informations de ce poseur. Laissez le mot de passe vide pour le conserver.',
    field_prenom: 'Prénom',
    field_nom: 'Nom',
    field_email: 'Email',
    field_password: 'Mot de passe',
    field_password_temp: 'Mot de passe temporaire',
    field_password_optional: '(laisser vide pour conserver)',
    password_hint_min: 'Min. 6 caractères',
    password_hint_new: 'Nouveau mot de passe (optionnel)',
    password_share_hint: 'Communiquez ces identifiants à votre poseur par un canal sécurisé.',
    btn_cancel: 'Annuler',
    btn_create_account: 'Créer le compte',
    btn_save: 'Enregistrer',
    saving: 'Enregistrement…',
    // Confirmations
    confirm_deactivate: 'Désactiver',
    confirm_reactivate: 'Réactiver',
    confirm_delete_poseur_title: 'Supprimer définitivement ce poseur ?',
    confirm_delete_poseur_body: 'Cette action est irréversible. Le poseur ne pourra plus se connecter mais ses chantiers réalisés resteront visibles dans votre historique.',
    // Language switcher
    lang_label: 'Langue',
  },
  en: {
    // Header / Navigation
    nav_home: 'Home',
    nav_new_chantier: 'New site',
    nav_my_chantiers: 'My sites',
    nav_new_short: 'New',
    nav_chantiers_short: 'Sites',
    nav_more: 'More',
    nav_team: 'My team',
    nav_profile: 'My profile',
    nav_logout: 'Logout',
    role_installateur: 'Installer',
    role_poseur: 'Field technician',
    // Wizard
    step1_title: 'Client information',
    section_logement: 'Housing information',
    lbl_civilite: 'Title',
    lbl_type_logement: 'Housing type',
    lbl_surface: 'Surface (m²)',
    lbl_mode_chauffage: 'Heating mode',
    lbl_region: 'Region',
    lbl_region_placeholder: 'Select a region',
    lbl_pdl_prm_hint: '14 digits',
    lbl_find_pdl: 'Find your PDL',
    lbl_step_progress: 'Step',
    step2_title: 'Installed equipment',
    step3_title: 'Consents & signature',
    step4_title: 'Summary',
    field_reference_chantier: 'Site reference',
    field_reference_chantier_hint: 'Your own site reference (required). It stays free text: we add our own identifier to it.',
    field_client_prenom: 'Client first name',
    field_client_nom: 'Client last name',
    field_client_email: 'Client email',
    field_client_telephone: 'Client phone',
    field_obligatoire: 'Required',
    field_adresse: 'Site address',
    field_code_postal: 'Postal code',
    field_ville: 'City',
    field_pdl_prm: 'PRM / PDL number',
    equip_section_title: 'Installed equipment',
    equip_pv: 'Photovoltaic panels (PV)',
    equip_batterie: 'Storage battery',
    equip_ballon: 'Water heater',
    equip_pac: 'Heat pump',
    equip_radiateur: 'Electric radiator',
    equip_activate: 'Enable',
    lbl_puissance_kwc: 'Total power (kWp)',
    lbl_puissance_kw: 'Power (kW)',
    lbl_marque: 'Brand',
    lbl_modele: 'Model',
    lbl_reference: 'Reference',
    lbl_type_onduleur: 'Inverter type',
    lbl_onduleur_centralise: 'Centralized inverter',
    lbl_onduleur_centralise_desc: 'One inverter for all panels',
    lbl_onduleur_micro: 'Micro-inverters',
    lbl_onduleur_micro_desc: 'One micro-inverter per panel (Hoymiles…)',
    lbl_id_centrale: 'Central ID',
    lbl_onduleur_marque: 'Inverter brand',
    lbl_onduleur_modele: 'Inverter model',
    lbl_onduleur_serial: 'Inverter serial number',
    lbl_panneaux_section: 'Photovoltaic panels',
    lbl_panneau_marque: 'Panel brand',
    lbl_panneau_modele: 'Panel model',
    lbl_nombre_panneaux: 'Number of panels',
    lbl_puissance_panneau: 'Power / panel (Wp)',
    lbl_serie_pac: 'Heat pump serial number',
    lbl_serie_pac_int: 'Indoor unit serial number',
    lbl_serie_pac_ext: 'Outdoor unit serial number',
    lbl_thermostat_ref: 'Thermostat reference',
    lbl_thermostat_serial: 'Thermostat serial number',
    lbl_type_ballon: 'Technology',
    lbl_nombre_ballons: 'Number of tanks',
    lbl_radiateur_rang: 'Radiator',
    btn_ajouter_radiateur: 'Add a radiator',
    btn_retirer: 'Remove',
    lbl_identifiant_equipement: 'Equipment ID',
    lbl_date_installation: 'Installation date',
    lbl_photos_section: 'Serial number label photos (required)',
    lbl_optional: '(optional)',
    lbl_required_symbol: ' *',
    btn_next: 'Next',
    btn_previous: 'Previous',
    btn_confirm: 'Confirm & sign',
    btn_finalize: 'Finalize',
    // Home Poseur
    poseur_hello: 'Hello',
    poseur_welcome_msg: 'Ready to start a new site?',
    poseur_stat_month: 'Sites this month',
    poseur_stat_total: 'Total',
    poseur_new_chantier_btn: 'New site',
    poseur_last_chantiers: 'My latest sites',
    poseur_no_chantiers: 'No site completed yet.',
    poseur_see_all: 'See all',
    status_signed: 'Signed',
    status_pending: 'Pending',
    // Home Installateur
    inst_welcome: 'Welcome',
    inst_stat_month: 'Sites this month',
    inst_stat_total: 'Total sites',
    inst_quick_create_poseur_title: 'Create technician',
    inst_quick_create_poseur_desc: 'New field technician',
    inst_quick_see_chantiers_title: 'View my sites',
    inst_quick_see_chantiers_desc: 'Full history',
    inst_my_poseurs: 'My technicians',
    inst_manage_team: 'Manage team',
    inst_no_poseurs: 'No technicians yet. Create one to get started.',
    inst_last_chantiers: 'Latest completed sites',
    inst_no_last_chantiers: 'No sites completed.',
    inst_by: 'By',
    connection_connected: 'Connected (< 24h)',
    connection_inactive: 'Inactive',
    connection_disabled: 'Disabled',
    chantier_singular: 'site',
    chantier_plural: 'sites',
    // Team
    team_title: 'My team',
    team_subtitle: 'Manage your field technician accounts',
    team_new_poseur: 'New technician',
    team_no_poseur_title: 'No technician created',
    team_no_poseur_desc: 'Create your first technician account to get started.',
    team_created_on: 'Created on',
    team_edit: 'Edit',
    team_deactivate: 'Disable',
    team_reactivate: 'Enable',
    team_delete: 'Delete',
    // Dialog
    poseur_dialog_create_title: 'Create a technician account',
    poseur_dialog_edit_title: 'Edit technician',
    poseur_dialog_create_desc: 'The technician will be able to log in to CFTSign with the credentials below and sign sites on your behalf.',
    poseur_dialog_edit_desc: 'Edit this technician\'s information. Leave the password blank to keep it.',
    field_prenom: 'First name',
    field_nom: 'Last name',
    field_email: 'Email',
    field_password: 'Password',
    field_password_temp: 'Temporary password',
    field_password_optional: '(leave blank to keep)',
    password_hint_min: 'Min. 6 characters',
    password_hint_new: 'New password (optional)',
    password_share_hint: 'Share these credentials with your technician via a secure channel.',
    btn_cancel: 'Cancel',
    btn_create_account: 'Create account',
    btn_save: 'Save',
    saving: 'Saving…',
    confirm_deactivate: 'Disable',
    confirm_reactivate: 'Enable',
    confirm_delete_poseur_title: 'Permanently delete this technician?',
    confirm_delete_poseur_body: 'This action is irreversible. The technician will not be able to log in anymore, but completed sites will remain visible in your history.',
    lang_label: 'Language',
  },
  ro: {
    // Wizard
    step1_title: 'Informații client',
    section_logement: 'Informații locuință',
    lbl_civilite: 'Titlu',
    lbl_type_logement: 'Tip locuință',
    lbl_surface: 'Suprafață (m²)',
    lbl_mode_chauffage: 'Mod de încălzire',
    lbl_region: 'Regiune',
    lbl_region_placeholder: 'Selectați o regiune',
    lbl_pdl_prm_hint: '14 cifre',
    lbl_find_pdl: 'Găsiți PDL',
    lbl_step_progress: 'Pas',
    step2_title: 'Echipament instalat',
    step3_title: 'Consimțăminte și semnătură',
    step4_title: 'Recapitulare',
    field_reference_chantier: 'Referință șantier',
    field_reference_chantier_hint: 'Referința dumneavoastră de șantier (obligatoriu). Rămâne text liber: adăugăm noi identificatorul nostru.',
    field_client_prenom: 'Prenume client',
    field_client_nom: 'Nume client',
    field_client_email: 'E-mail client',
    field_client_telephone: 'Telefon client',
    field_obligatoire: 'Obligatoriu',
    field_adresse: 'Adresa șantierului',
    field_code_postal: 'Cod poștal',
    field_ville: 'Oraș',
    field_pdl_prm: 'Număr PRM / PDL',
    equip_section_title: 'Echipament instalat',
    equip_pv: 'Panouri fotovoltaice (PV)',
    equip_batterie: 'Baterie de stocare',
    equip_ballon: 'Boiler',
    equip_pac: 'Pompă de căldură',
    equip_radiateur: 'Radiator electric',
    equip_activate: 'Activează',
    lbl_puissance_kwc: 'Putere totală (kWc)',
    lbl_puissance_kw: 'Putere (kW)',
    lbl_marque: 'Marcă',
    lbl_modele: 'Model',
    lbl_reference: 'Referință',
    lbl_type_onduleur: 'Tip invertor',
    lbl_onduleur_centralise: 'Invertor centralizat',
    lbl_onduleur_centralise_desc: 'Un singur invertor pentru toate panourile',
    lbl_onduleur_micro: 'Micro-invertoare',
    lbl_onduleur_micro_desc: 'Un micro-invertor pe panou (Hoymiles…)',
    lbl_id_centrale: 'ID central',
    lbl_onduleur_marque: 'Marca invertorului',
    lbl_onduleur_modele: 'Model invertor',
    lbl_onduleur_serial: 'Serie invertor',
    lbl_panneaux_section: 'Panouri fotovoltaice',
    lbl_panneau_marque: 'Marcă panou',
    lbl_panneau_modele: 'Model panou',
    lbl_nombre_panneaux: 'Număr panouri',
    lbl_puissance_panneau: 'Putere / panou (Wc)',
    lbl_serie_pac: 'Serie pompă de căldură',
    lbl_serie_pac_int: 'Serie unitate interioară',
    lbl_serie_pac_ext: 'Serie unitate exterioară',
    lbl_thermostat_ref: 'Referință termostat',
    lbl_thermostat_serial: 'Serie termostat',
    lbl_type_ballon: 'Tehnologie',
    lbl_nombre_ballons: 'Număr boilere',
    lbl_radiateur_rang: 'Radiator',
    btn_ajouter_radiateur: 'Adaugă un radiator',
    btn_retirer: 'Elimină',
    lbl_identifiant_equipement: 'Identificator echipament',
    lbl_date_installation: 'Data instalării',
    lbl_photos_section: 'Fotografii etichete serie (obligatorii)',
    lbl_optional: '(opțional)',
    lbl_required_symbol: ' *',
    btn_next: 'Următorul',
    btn_previous: 'Anterior',
    btn_confirm: 'Confirmă și semnează',
    btn_finalize: 'Finalizează',
    // Navigation & general
    nav_home: 'Acasă',
    nav_new_chantier: 'Șantier nou',
    nav_my_chantiers: 'Șantierele mele',
    nav_new_short: 'Nou',
    nav_chantiers_short: 'Șantiere',
    nav_more: 'Mai mult',
    nav_team: 'Echipa mea',
    nav_profile: 'Profilul meu',
    nav_logout: 'Deconectare',
    role_installateur: 'Instalator',
    role_poseur: 'Montator',
    poseur_hello: 'Bună ziua',
    poseur_welcome_msg: 'Gata să începeți un șantier nou?',
    poseur_stat_month: 'Șantiere luna aceasta',
    poseur_stat_total: 'Total',
    poseur_new_chantier_btn: 'Șantier nou',
    poseur_last_chantiers: 'Ultimele mele șantiere',
    poseur_no_chantiers: 'Niciun șantier realizat momentan.',
    poseur_see_all: 'Vezi toate',
    status_signed: 'Semnat',
    status_pending: 'În așteptare',
    inst_welcome: 'Bine ați venit',
    inst_stat_month: 'Șantiere luna aceasta',
    inst_stat_total: 'Total șantiere',
    inst_quick_create_poseur_title: 'Creare montator',
    inst_quick_create_poseur_desc: 'Nou tehnician de teren',
    inst_quick_see_chantiers_title: 'Vezi șantierele mele',
    inst_quick_see_chantiers_desc: 'Istoric complet',
    inst_my_poseurs: 'Montatorii mei',
    inst_manage_team: 'Gestionează echipa',
    inst_no_poseurs: 'Niciun montator momentan. Creați unul pentru a începe.',
    inst_last_chantiers: 'Ultimele șantiere realizate',
    inst_no_last_chantiers: 'Niciun șantier realizat.',
    inst_by: 'De',
    connection_connected: 'Conectat (< 24h)',
    connection_inactive: 'Inactiv',
    connection_disabled: 'Dezactivat',
    chantier_singular: 'șantier',
    chantier_plural: 'șantiere',
    team_title: 'Echipa mea',
    team_subtitle: 'Gestionați conturile montatorilor dumneavoastră',
    team_new_poseur: 'Montator nou',
    team_no_poseur_title: 'Niciun montator creat',
    team_no_poseur_desc: 'Creați primul cont de montator pentru echipa dumneavoastră.',
    team_created_on: 'Creat pe',
    team_edit: 'Modifică',
    team_deactivate: 'Dezactivează',
    team_reactivate: 'Reactivează',
    team_delete: 'Șterge',
    poseur_dialog_create_title: 'Creați un cont de montator',
    poseur_dialog_edit_title: 'Modificați montatorul',
    poseur_dialog_create_desc: 'Montatorul se va putea conecta la CFTSign cu identificatorii de mai jos și va semna șantiere în numele dumneavoastră.',
    poseur_dialog_edit_desc: 'Modificați informațiile acestui montator. Lăsați parola goală pentru a o păstra.',
    field_prenom: 'Prenume',
    field_nom: 'Nume',
    field_email: 'E-mail',
    field_password: 'Parolă',
    field_password_temp: 'Parolă temporară',
    field_password_optional: '(lăsați gol pentru a păstra)',
    password_hint_min: 'Min. 6 caractere',
    password_hint_new: 'Parolă nouă (opțional)',
    password_share_hint: 'Comunicați aceste identificatori montatorului printr-un canal securizat.',
    btn_cancel: 'Anulează',
    btn_create_account: 'Creează contul',
    btn_save: 'Salvează',
    saving: 'Salvare…',
    confirm_deactivate: 'Dezactivează',
    confirm_reactivate: 'Reactivează',
    confirm_delete_poseur_title: 'Ștergeți definitiv acest montator?',
    confirm_delete_poseur_body: 'Această acțiune este ireversibilă. Montatorul nu se va mai putea conecta, dar șantierele realizate vor rămâne vizibile în istoricul dumneavoastră.',
    lang_label: 'Limbă',
  },
  mo: {
    // Wizard (identique à ro)
    step1_title: 'Informații client',
    section_logement: 'Informații locuință',
    lbl_civilite: 'Titlu',
    lbl_type_logement: 'Tip locuință',
    lbl_surface: 'Suprafață (m²)',
    lbl_mode_chauffage: 'Mod de încălzire',
    lbl_region: 'Regiune',
    lbl_region_placeholder: 'Selectați o regiune',
    lbl_pdl_prm_hint: '14 cifre',
    lbl_find_pdl: 'Găsiți PDL',
    lbl_step_progress: 'Pas',
    step2_title: 'Echipament instalat',
    step3_title: 'Consimțăminte și semnătură',
    step4_title: 'Recapitulare',
    field_reference_chantier: 'Referință șantier',
    field_reference_chantier_hint: 'Referința dumneavoastră de șantier (obligatoriu). Rămâne text liber: adăugăm noi identificatorul nostru.',
    field_client_prenom: 'Prenume client',
    field_client_nom: 'Nume client',
    field_client_email: 'E-mail client',
    field_client_telephone: 'Telefon client',
    field_obligatoire: 'Obligatoriu',
    field_adresse: 'Adresa șantierului',
    field_code_postal: 'Cod poștal',
    field_ville: 'Oraș',
    field_pdl_prm: 'Număr PRM / PDL',
    equip_section_title: 'Echipament instalat',
    equip_pv: 'Panouri fotovoltaice (PV)',
    equip_batterie: 'Baterie de stocare',
    equip_ballon: 'Boiler',
    equip_pac: 'Pompă de căldură',
    equip_radiateur: 'Radiator electric',
    equip_activate: 'Activează',
    lbl_puissance_kwc: 'Putere totală (kWc)',
    lbl_puissance_kw: 'Putere (kW)',
    lbl_marque: 'Marcă',
    lbl_modele: 'Model',
    lbl_reference: 'Referință',
    lbl_type_onduleur: 'Tip invertor',
    lbl_onduleur_centralise: 'Invertor centralizat',
    lbl_onduleur_centralise_desc: 'Un singur invertor pentru toate panourile',
    lbl_onduleur_micro: 'Micro-invertoare',
    lbl_onduleur_micro_desc: 'Un micro-invertor pe panou (Hoymiles…)',
    lbl_id_centrale: 'ID central',
    lbl_onduleur_marque: 'Marca invertorului',
    lbl_onduleur_modele: 'Model invertor',
    lbl_onduleur_serial: 'Serie invertor',
    lbl_panneaux_section: 'Panouri fotovoltaice',
    lbl_panneau_marque: 'Marcă panou',
    lbl_panneau_modele: 'Model panou',
    lbl_nombre_panneaux: 'Număr panouri',
    lbl_puissance_panneau: 'Putere / panou (Wc)',
    lbl_serie_pac: 'Serie pompă de căldură',
    lbl_serie_pac_int: 'Serie unitate interioară',
    lbl_serie_pac_ext: 'Serie unitate exterioară',
    lbl_thermostat_ref: 'Referință termostat',
    lbl_thermostat_serial: 'Serie termostat',
    lbl_type_ballon: 'Tehnologie',
    lbl_nombre_ballons: 'Număr boilere',
    lbl_radiateur_rang: 'Radiator',
    btn_ajouter_radiateur: 'Adaugă un radiator',
    btn_retirer: 'Elimină',
    lbl_identifiant_equipement: 'Identificator echipament',
    lbl_date_installation: 'Data instalării',
    lbl_photos_section: 'Fotografii etichete serie (obligatorii)',
    lbl_optional: '(opțional)',
    lbl_required_symbol: ' *',
    btn_next: 'Următorul',
    btn_previous: 'Anterior',
    btn_confirm: 'Confirmă și semnează',
    btn_finalize: 'Finalizează',
    // Navigation
    nav_home: 'Acasă',
    nav_new_chantier: 'Șantier nou',
    nav_my_chantiers: 'Șantierele mele',
    nav_new_short: 'Nou',
    nav_chantiers_short: 'Șantiere',
    nav_more: 'Mai mult',
    nav_team: 'Echipa mea',
    nav_profile: 'Profilul meu',
    nav_logout: 'Deconectare',
    role_installateur: 'Instalator',
    role_poseur: 'Montator',
    poseur_hello: 'Bună ziua',
    poseur_welcome_msg: 'Gata să începeți un șantier nou?',
    poseur_stat_month: 'Șantiere luna aceasta',
    poseur_stat_total: 'Total',
    poseur_new_chantier_btn: 'Șantier nou',
    poseur_last_chantiers: 'Ultimele mele șantiere',
    poseur_no_chantiers: 'Niciun șantier realizat momentan.',
    poseur_see_all: 'Vezi toate',
    status_signed: 'Semnat',
    status_pending: 'În așteptare',
    inst_welcome: 'Bine ați venit',
    inst_stat_month: 'Șantiere luna aceasta',
    inst_stat_total: 'Total șantiere',
    inst_quick_create_poseur_title: 'Creare montator',
    inst_quick_create_poseur_desc: 'Nou tehnician de teren',
    inst_quick_see_chantiers_title: 'Vezi șantierele mele',
    inst_quick_see_chantiers_desc: 'Istoric complet',
    inst_my_poseurs: 'Montatorii mei',
    inst_manage_team: 'Gestionează echipa',
    inst_no_poseurs: 'Niciun montator momentan. Creați unul pentru a începe.',
    inst_last_chantiers: 'Ultimele șantiere realizate',
    inst_no_last_chantiers: 'Niciun șantier realizat.',
    inst_by: 'De',
    connection_connected: 'Conectat (< 24h)',
    connection_inactive: 'Inactiv',
    connection_disabled: 'Dezactivat',
    chantier_singular: 'șantier',
    chantier_plural: 'șantiere',
    team_title: 'Echipa mea',
    team_subtitle: 'Gestionați conturile montatorilor dumneavoastră',
    team_new_poseur: 'Montator nou',
    team_no_poseur_title: 'Niciun montator creat',
    team_no_poseur_desc: 'Creați primul cont de montator pentru echipa dumneavoastră.',
    team_created_on: 'Creat pe',
    team_edit: 'Modifică',
    team_deactivate: 'Dezactivează',
    team_reactivate: 'Reactivează',
    team_delete: 'Șterge',
    poseur_dialog_create_title: 'Creați un cont de montator',
    poseur_dialog_edit_title: 'Modificați montatorul',
    poseur_dialog_create_desc: 'Montatorul se va putea conecta la CFTSign cu identificatorii de mai jos și va semna șantiere în numele dumneavoastră.',
    poseur_dialog_edit_desc: 'Modificați informațiile acestui montator. Lăsați parola goală pentru a o păstra.',
    field_prenom: 'Prenume',
    field_nom: 'Nume',
    field_email: 'E-mail',
    field_password: 'Parolă',
    field_password_temp: 'Parolă temporară',
    field_password_optional: '(lăsați gol pentru a păstra)',
    password_hint_min: 'Min. 6 caractere',
    password_hint_new: 'Parolă nouă (opțional)',
    password_share_hint: 'Comunicați aceste identificatori montatorului printr-un canal securizat.',
    btn_cancel: 'Anulează',
    btn_create_account: 'Creează contul',
    btn_save: 'Salvează',
    saving: 'Salvare…',
    confirm_deactivate: 'Dezactivează',
    confirm_reactivate: 'Reactivează',
    confirm_delete_poseur_title: 'Ștergeți definitiv acest montator?',
    confirm_delete_poseur_body: 'Această acțiune este ireversibilă. Montatorul nu se va mai putea conecta, dar șantierele realizate vor rămâne vizibile în istoricul dumneavoastră.',
    lang_label: 'Limbă',
  },
  pl: {
    // Wizard
    step1_title: 'Informacje o kliencie',
    section_logement: 'Informacje o lokalu',
    lbl_civilite: 'Tytuł',
    lbl_type_logement: 'Typ lokalu',
    lbl_surface: 'Powierzchnia (m²)',
    lbl_mode_chauffage: 'Tryb ogrzewania',
    lbl_region: 'Region',
    lbl_region_placeholder: 'Wybierz region',
    lbl_pdl_prm_hint: '14 cyfr',
    lbl_find_pdl: 'Znajdź PDL',
    lbl_step_progress: 'Krok',
    step2_title: 'Zainstalowany sprzęt',
    step3_title: 'Zgody i podpis',
    step4_title: 'Podsumowanie',
    field_reference_chantier: 'Numer placu',
    field_reference_chantier_hint: 'Twoje oznaczenie placu (wymagane). Pozostaje dowolnym tekstem: dodajemy do niego nasz identyfikator.',
    field_client_prenom: 'Imię klienta',
    field_client_nom: 'Nazwisko klienta',
    field_client_email: 'E-mail klienta',
    field_client_telephone: 'Telefon klienta',
    field_obligatoire: 'Wymagane',
    field_adresse: 'Adres placu',
    field_code_postal: 'Kod pocztowy',
    field_ville: 'Miasto',
    field_pdl_prm: 'Numer PRM / PDL',
    equip_section_title: 'Zainstalowany sprzęt',
    equip_pv: 'Panele fotowoltaiczne (PV)',
    equip_batterie: 'Bateria magazynująca',
    equip_ballon: 'Zbiornik ciepłej wody',
    equip_pac: 'Pompa ciepła',
    equip_radiateur: 'Grzejnik elektryczny',
    equip_activate: 'Włącz',
    lbl_puissance_kwc: 'Moc całkowita (kWp)',
    lbl_puissance_kw: 'Moc (kW)',
    lbl_marque: 'Marka',
    lbl_modele: 'Model',
    lbl_reference: 'Numer',
    lbl_type_onduleur: 'Typ falownika',
    lbl_onduleur_centralise: 'Falownik centralny',
    lbl_onduleur_centralise_desc: 'Jeden falownik dla wszystkich paneli',
    lbl_onduleur_micro: 'Mikrofalowniki',
    lbl_onduleur_micro_desc: 'Jeden mikrofalownik na panel (Hoymiles…)',
    lbl_id_centrale: 'ID centrali',
    lbl_onduleur_marque: 'Marka falownika',
    lbl_onduleur_modele: 'Model falownika',
    lbl_onduleur_serial: 'Numer seryjny falownika',
    lbl_panneaux_section: 'Panele fotowoltaiczne',
    lbl_panneau_marque: 'Marka panelu',
    lbl_panneau_modele: 'Model panelu',
    lbl_nombre_panneaux: 'Liczba paneli',
    lbl_puissance_panneau: 'Moc / panel (Wp)',
    lbl_serie_pac: 'Numer seryjny pompy ciepła',
    lbl_serie_pac_int: 'Numer seryjny jednostki wewnętrznej',
    lbl_serie_pac_ext: 'Numer seryjny jednostki zewnętrznej',
    lbl_thermostat_ref: 'Numer termostatu',
    lbl_thermostat_serial: 'Numer seryjny termostatu',
    lbl_type_ballon: 'Technologia',
    lbl_nombre_ballons: 'Liczba zbiorników',
    lbl_radiateur_rang: 'Grzejnik',
    btn_ajouter_radiateur: 'Dodaj grzejnik',
    btn_retirer: 'Usuń',
    lbl_identifiant_equipement: 'ID sprzętu',
    lbl_date_installation: 'Data instalacji',
    lbl_photos_section: 'Zdjęcia etykiet z numerem seryjnym (wymagane)',
    lbl_optional: '(opcjonalne)',
    lbl_required_symbol: ' *',
    btn_next: 'Dalej',
    btn_previous: 'Wstecz',
    btn_confirm: 'Potwierdź i podpisz',
    btn_finalize: 'Zakończ',
    // Navigation
    nav_home: 'Strona główna',
    nav_new_chantier: 'Nowy plac',
    nav_my_chantiers: 'Moje place',
    nav_new_short: 'Nowy',
    nav_chantiers_short: 'Place',
    nav_more: 'Więcej',
    nav_team: 'Mój zespół',
    nav_profile: 'Mój profil',
    nav_logout: 'Wyloguj',
    role_installateur: 'Instalator',
    role_poseur: 'Monter',
    poseur_hello: 'Dzień dobry',
    poseur_welcome_msg: 'Gotowy na nowy plac?',
    poseur_stat_month: 'Place w tym miesiącu',
    poseur_stat_total: 'Razem',
    poseur_new_chantier_btn: 'Nowy plac',
    poseur_last_chantiers: 'Moje ostatnie place',
    poseur_no_chantiers: 'Brak zrealizowanych placów.',
    poseur_see_all: 'Zobacz wszystkie',
    status_signed: 'Podpisany',
    status_pending: 'Oczekujący',
    inst_welcome: 'Witamy',
    inst_stat_month: 'Place w tym miesiącu',
    inst_stat_total: 'Wszystkie place',
    inst_quick_create_poseur_title: 'Utwórz montera',
    inst_quick_create_poseur_desc: 'Nowy technik terenowy',
    inst_quick_see_chantiers_title: 'Moje place',
    inst_quick_see_chantiers_desc: 'Pełna historia',
    inst_my_poseurs: 'Moi monterzy',
    inst_manage_team: 'Zarządzaj zespołem',
    inst_no_poseurs: 'Brak monterów. Utwórz jednego, aby rozpocząć.',
    inst_last_chantiers: 'Ostatnio zrealizowane place',
    inst_no_last_chantiers: 'Brak zrealizowanych placów.',
    inst_by: 'Przez',
    connection_connected: 'Połączony (< 24h)',
    connection_inactive: 'Nieaktywny',
    connection_disabled: 'Wyłączony',
    chantier_singular: 'plac',
    chantier_plural: 'place',
    team_title: 'Mój zespół',
    team_subtitle: 'Zarządzaj kontami monterów terenowych',
    team_new_poseur: 'Nowy monter',
    team_no_poseur_title: 'Brak utworzonych monterów',
    team_no_poseur_desc: 'Utwórz pierwsze konto montera dla swojego zespołu.',
    team_created_on: 'Utworzono',
    team_edit: 'Edytuj',
    team_deactivate: 'Wyłącz',
    team_reactivate: 'Włącz',
    team_delete: 'Usuń',
    poseur_dialog_create_title: 'Utwórz konto montera',
    poseur_dialog_edit_title: 'Edytuj montera',
    poseur_dialog_create_desc: 'Monter będzie mógł zalogować się do CFTSign i podpisywać place w Twoim imieniu.',
    poseur_dialog_edit_desc: 'Zaktualizuj dane montera. Pozostaw hasło puste, aby je zachować.',
    field_prenom: 'Imię',
    field_nom: 'Nazwisko',
    field_email: 'E-mail',
    field_password: 'Hasło',
    field_password_temp: 'Hasło tymczasowe',
    field_password_optional: '(pozostaw puste, aby zachować)',
    password_hint_min: 'Min. 6 znaków',
    password_hint_new: 'Nowe hasło (opcjonalne)',
    password_share_hint: 'Przekaż te dane monterowi bezpiecznym kanałem.',
    btn_cancel: 'Anuluj',
    btn_create_account: 'Utwórz konto',
    btn_save: 'Zapisz',
    saving: 'Zapisywanie…',
    confirm_deactivate: 'Wyłącz',
    confirm_reactivate: 'Włącz',
    confirm_delete_poseur_title: 'Usunąć tego montera na stałe?',
    confirm_delete_poseur_body: 'Ta akcja jest nieodwracalna. Monter nie będzie mógł się już zalogować, ale zrealizowane place pozostaną widoczne w historii.',
    lang_label: 'Język',
  },
};

const STORAGE_KEY = 'cftsign_language';

export function getSavedLanguage() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved && TRANSLATIONS[saved]) return saved;
  } catch { /* ignore */ }
  return 'fr';
}

export function saveLanguage(code) {
  try { localStorage.setItem(STORAGE_KEY, code); } catch { /* ignore */ }
}

export function translate(lang, key, fallback) {
  return (TRANSLATIONS[lang] && TRANSLATIONS[lang][key]) || TRANSLATIONS.fr[key] || fallback || key;
}
